import React from 'react';

import { c } from 'ttag';

import { Close } from '@freelancelabs/icons';

export interface Chip {
    id: string;
    /** What is filtered: « Statut », « Compte ». */
    label: string;
    /** What it is filtered on: « Invité », « EDF Renouvelables ». */
    value: string;
    onRemove: () => void;
}

interface Props {
    chips: Chip[];
    onClearAll: () => void;
}

/**
 * The active filters, each removable on its own (mockup §5.2).
 *
 * They are not a duplicate of the controls: a collapsed select shows its value, a
 * search field scrolled out of view shows nothing, and « why is this list almost
 * empty » is the question they answer. « Clear filters » only appears past the
 * second one: with a single chip, its own cross is the shorter path.
 */
const FilterChips = ({ chips, onClearAll }: Props) => {
    if (chips.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center gap-2">
            {chips.map((chip) => (
                <span
                    key={chip.id}
                    className="inline-flex items-center gap-1.5 rounded-full border border-admin-accent-border bg-admin-accent-soft px-2.5 py-0.5 text-xs text-admin-accent-hover"
                >
                    <span>
                        {chip.label} : <b className="font-medium">{chip.value}</b>
                    </span>
                    <button
                        type="button"
                        onClick={chip.onRemove}
                        className="rounded-full p-0.5 hover:bg-admin-accent-border"
                        // The name carries what is removed: « remove » alone, heard four
                        // times in a row, names nothing.
                        aria-label={c('Users filter').t`Remove the filter ${chip.label}`}
                    >
                        <Close size={12} />
                    </button>
                </span>
            ))}
            {chips.length > 1 && (
                <button type="button" onClick={onClearAll} className="link text-xs">
                    {c('Users filter').t`Clear filters`}
                </button>
            )}
        </div>
    );
};

export default FilterChips;
